import { useMutation } from '@tanstack/vue-query'
import type { SuccessResponse } from '~/types/response'
import { tokenKey } from '~/constants/auth'

const useLogout = () => {
  const { logout } = useSuccessfulLogout()
  const token = useStatefulCookie(tokenKey)

  return useMutation({
    mutationFn: async () => {
      if (token.value) {
        await $fetch<SuccessResponse<{}>>('/api/users/logout', {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token.value}`,
          },
        })
      }
    },
    onSettled: async () => {
      await logout()
    },
  })
}

export default useLogout
